
// LOAD SCRIPTS AFTER PAGE FULLY LOADED

document.addEventListener('DOMContentLoaded', function () {

      /* Menu mobile */
      const burger = document.querySelector('.burger');
      const menumobile = document.querySelector('.menu-mobile');
      const body = document.body;

    /*  button.addEventListener('click', () => {
        button.classList.toggle('-menu-open');
        menu.classList.toggle('-open');
      })*/

      burger.onclick = function() {

        // Toggle class "opened". Set also aria-expanded to true or false.
        if ( -1 !== burger.className.indexOf( 'is-active' ) ) {
            burger.className = burger.className.replace( ' is-active', '' );
            burger.setAttribute( 'aria-expanded', 'false' );

        } else {
            burger.className += ' is-active';
            burger.setAttribute( 'aria-expanded', 'true' );
        }

          // Toggle class "opened". Set also aria-expanded to true or false.
          if ( -1 !== menumobile.className.indexOf( 'is-active' ) ) {
            menumobile.className = menumobile.className.replace( ' is-active', '' );
            menumobile.setAttribute( 'aria-hidden', 'true' );
            body.classList.remove("is-menu-open");
          } else {
            menumobile.className += ' is-active';
            menumobile.setAttribute( 'aria-hidden', 'false' );
            body.classList.add("is-menu-open");
          }
      };





/* Resize titles */
// Get all elements with the class "resize-container"
const resizeContainers = document.querySelectorAll('.resize-container');

// Resize the text for each element
resizeContainers.forEach(container => {
  const resizeText = container.querySelector('div');
  const computedStyle = window.getComputedStyle(resizeText);
  const originalFontSize = parseInt(computedStyle.getPropertyValue('font-size'), 10);
  let fontSize = originalFontSize;
  let lineHeight = parseFloat(computedStyle.getPropertyValue('line-height'));

  function resizeTextToFit() {
    const containerWidth = parseInt(window.getComputedStyle(container).getPropertyValue('width'), 10);
    const textContent = resizeText.textContent;
    const words = textContent.split(' ');
    let longestLine = '';
    let longestLineLength = 0;
    let currentLine = '';
    let currentLineLength = 0;
    const IgnoreLetters = /[li\s.]/g;

    resizeText.classList.remove("small");

    words.forEach(word => {
      currentLineLength += word.replace(IgnoreLetters, '').length + 1; // Add 1 for the space between words

      // Long words (like "Cordonnateur(trice)") break up the maths. Add some buffer.
      if (currentLineLength > 11) currentLineLength = 42;
      if (word.length > 11) resizeText.classList.add("small");

      if (currentLineLength > longestLineLength) {
        longestLine = currentLine + word + ' ';
        longestLineLength = currentLineLength;
      }
      if (currentLineLength > containerWidth) {
        currentLine = word + ' ';
        currentLineLength = word.replace(IgnoreLetters, '').length + 1;
      } else {
        currentLine += word + ' ';
      }
    });
    longestLineLength /= 3;

    //console.log('title container divided by ' + (longestLineLength / 2));
    const newFontSize = containerWidth / ((longestLineLength / 2) + 4); // We can adjust this line if thes is overflowing. Character calculation isn't 100% accurate.
    if (newFontSize > originalFontSize) {
      fontSize = originalFontSize;
    } else {
      fontSize = newFontSize;
    }
    lineHeight = fontSize * 1.06;
    resizeText.style.fontSize = `${fontSize}px`;
    resizeText.style.lineHeight = `${lineHeight}px`;
  }

  window.addEventListener('load', resizeTextToFit);
  window.addEventListener('resize', resizeTextToFit);
});



document.body.classList.add('loaded');

// Call runFadeInAnimation() initially
runFadeInAnimation();
// Call updateSfCount() initially
updateSfCount();


// Watch for changes to the page content due to AJAX filters
(function ( $ ) {
  "use strict";
  $(document).on("sf:ajaxfinish", ".searchandfilter", function(){
    updateSfCount();
    runFadeInAnimation();
  });
}(jQuery));



/* LIGHT EFFECT ON HERO */

const hero = document.querySelector('#hero.hero-has-light');
const light = document.querySelector('.light');

if(hero){
    let mouseX = 0;
    let mouseY = 0;
    let lightX = 0;
    let lightY = 0;
    let speed = 0.1;



    function animate() {
    let distX = mouseX - lightX - 1;
    let distY = mouseY - lightY - 34;

    lightX = lightX + (distX * speed);
    lightY = lightY + (distY * speed);

    if(lightX == 0){
      light.style.left = '100vw'; // default position
    }else{
      light.style.left = lightX + 'px';
    }

    if(lightY == 0){
      light.style.top = '100vh'; // default position
    }else{
      light.style.top = lightY + 'px';
    }


    requestAnimationFrame(animate);
    }
    animate();

    document.body.addEventListener('mousemove', function(e){
    mouseX = e.pageX;
    mouseY = e.pageY;
    })
}


}) //END domcontentload



/* Scroll detection (add class to body when scrolling) */
const body = document.body;
const scrollUp = "scroll-up";
const scrollDown = "scroll-down";
const scrollTop = "scroll-top";
const scrollMiddle = "scroll-middle";
let lastScroll = 0;

if (window.pageYOffset <= 30) { //offset
    body.classList.add(scrollTop);
}else{
    body.classList.add(scrollMiddle);
}

window.addEventListener("scroll", () => {
    const currentScroll = window.pageYOffset;
    if (currentScroll <= 30) {//offset
        body.classList.remove(scrollUp);
        body.classList.remove(scrollMiddle);
        body.classList.add(scrollTop);
        return;
    }

    if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
        // down
        body.classList.remove(scrollTop);
        body.classList.remove(scrollUp);
        body.classList.remove(scrollMiddle);
        body.classList.add(scrollDown);
    } else if (
        currentScroll < lastScroll &&
        body.classList.contains(scrollDown)
    ) {
        // up
        body.classList.remove(scrollDown);
        body.classList.add(scrollUp);
    }
    lastScroll = currentScroll;
});



/* Accordions */
function setAccordionItemState(header, panel, isActive) {
  header.classList.toggle("active", isActive);
  panel.style.maxHeight = isActive ? panel.scrollHeight + "px" : 0;
  header.setAttribute("aria-expanded", isActive ? "true" : "false");
}

function createAccordion(selector, type, offset) {
  const accItemHeaders = document.querySelectorAll(`${selector} .accordion__head`);

  accItemHeaders.forEach(header => {
    header.addEventListener("click", event => {
      const panel = header.nextElementSibling;
      const isActive = header.classList.contains("active");

      if (type === "simple") {
        const activeHeader = document.querySelector(`${selector} .accordion__head.active`);

        if (activeHeader && activeHeader !== header) {
          const activePanel = activeHeader.nextElementSibling;
          setAccordionItemState(activeHeader, activePanel, false);

          // add event listener to wait for the transition to complete before scrolling and opening new item
          activePanel.addEventListener("transitionend", () => {
            const rect = header.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (isMobile()) {
                const targetTop = rect.top + scrollTop - offset;
                window.scrollTo({
                  top: targetTop,
                  behavior: "smooth"
                });
            }

            setAccordionItemState(header, panel, true);
          }, { once: true });
        } else {
          setAccordionItemState(header, panel, !isActive);

          if (!isActive) {
            const rect = header.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (isMobile()) {
                const targetTop = rect.top + scrollTop - offset;
                window.scrollTo({
                  top: targetTop,
                  behavior: "smooth"
                });
            }
          }
        }
      } else if (type === "multi") {
        setAccordionItemState(header, panel, !isActive);


          const rect = header.getBoundingClientRect();
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (isMobile()) {
              const targetTop = rect.top + scrollTop - offset;
              window.scrollTo({
                top: targetTop,
                behavior: "smooth"
              });
          }
      }
    });
  });

  window.addEventListener("resize", function () {
    accItemHeaders.forEach(header => {
      if (header.classList.contains("active")) {
        const panel = header.nextElementSibling;
        setAccordionItemState(header, panel, true);
      }
    });
  });

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }
}


  // Call accordion with custom offset
  createAccordion(".menu-mobile .accordion", "simple");
  createAccordion(".accordion--simple", "simple", 71);


function runFadeInAnimation() {
  const fadeIns = Array.from(document.querySelectorAll('.fade-in')).sort((a, b) => {
    const aRect = a.getBoundingClientRect();
    const bRect = b.getBoundingClientRect();

    // Sort elements by the sum of their vertical and horizontal position.
    return (aRect.top + aRect.left) - (bRect.top + bRect.left);
  });

  const delay = 200; // Adjust the delay duration as needed
  const maxDelay = 1000; // Adjust the maximum delay as needed

  const fadeInObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting && !entry.target.classList.contains('fade-in-visible')) {
        setTimeout(() => {
          entry.target.classList.add('fade-in-visible');
        }, Math.min(index * delay, maxDelay));
      }
    });
  }, {
    root: null,
    rootMargin: "-100px 0px -100px 0px",
    threshold: 0,
  });

  fadeIns.forEach((fadeIn) => {
    fadeIn.classList.add('fade-in-hidden');
    fadeInObserver.observe(fadeIn);
  });
}

// Call the function to run the fade-in animation
runFadeInAnimation();



// Trigger the animations when the page is loaded
/*window.addEventListener("DOMContentLoaded", (event) => {

});*/



/* update count on filters */

function updateSfCount() {
  // Select all elements with the sf-count class
  const countEls = document.querySelectorAll('.sf-count');

  // Loop through each sf-count element
  countEls.forEach(countEl => {
    // Check if the content has already been updated
    if (countEl.innerHTML.indexOf('<sup>') === -1) {
      // Replace any number in parentheses with a superscript
      const span = document.createElement('span');
      span.innerHTML = countEl.innerHTML.replace(/\((\d+)\)/g, '<sup>$1</sup>');
      countEl.innerHTML = span.innerHTML;
    }
  });
}







// LIGHTHOUSE AUDIT

// Sometimes, you need to force Google Lighthouse Test to ignore something for better debugging. With this function you can load some styles that only Google Lighthouse will load.
/*if (navigator.userAgent.indexOf("Chrome-Lighthouse") > -1) { var sheet = window.document.styleSheets[0];
   sheet.insertRule('.section-title__bg{ color: black!important;}', sheet.cssRules.length);
}*/




